import React, {useEffect, useState} from 'react';
import {getSubdomainSessionData} from '../utils/AppUtils';
import {useTheme} from '../../common/ProjectThemeProvider';
import {Keys, ModuleFieldsData, Modules} from '../config/AppConfig';
import {getJsonValue, setTabTitle} from '../../common/fusion-ui/utils/ReactUtils';
import {DefStrNA} from '../../common/fusion-ui/config/FusionConfig';
import {AppInterface} from "../index";
import {useConfig} from "../context/ConfigProvider";

const TermsOfUsePage = React.memo(() => {
    const TAG = "TermsOfUsePage";
    const theme = useTheme();
    const {updateConfig} = useConfig();

    const module = Modules.TermsOfUse;
    const mf = ModuleFieldsData[Modules.Company];

    const [termsData, setTermsData] = useState('');
    useEffect(() => {
        setTabTitle(module)
        updateConfig(Keys.config_ShowTabBar, false);
        updateConfig(Keys.config_showHomeRightPanels, false);
        updateConfig(Keys.tracker_currPageModule, module);
        updateConfig(Keys.tracker_currPageTag, TAG);
        setTermsData(getJsonValue(getSubdomainSessionData(), mf.privacyPolicy.column, DefStrNA));
    }, []);

    return (<>
            <AppInterface label={module} showHome={true}>
                <div className={`text-wrap`} style={{color: theme.text}}
                     dangerouslySetInnerHTML={{__html: termsData}}
                />
            </AppInterface>
        </>
    );
})
export default TermsOfUsePage;
